<template>
    <div
        class="fixed inset-0 overflow-y-auto bg-center bg-no-repeat md:flex bg-blue-bg scrolls-to-top"
        :style="{
            'background-image': 'url(/img/hero-background-dark.svg), url(/img/misc-background.svg)',
            'background-position': 'top -20px center, bottom -60px left 120px',
            'background-size': '1747px 912px, 462px 600px'
        }"
    >
        <div class="absolute inset-x-0 top-0 w-full bg-blue h-1-5" />

        <div class="relative w-full mx-auto md:flex md:flex-col md:items-center md:h-screen">
            <div class="w-full md:flex-grow md:flex md:items-center">
                <div class="container px-3 py-6 mx-auto sm:px-6">
                    <div class="text-center">
                        <laroute-link
                            :to="{ name: 'www.home.index' }"
                            class="inline-block mx-auto mb-3 sm:mb-6"
                        >
                            <base-svg
                                name="logo-rentora"
                                class="h-6 fill-primary-blue"
                            />
                        </laroute-link>
                    </div>

                    <div class="flex flex-col items-center">
                        <div
                            :class="[
                                maxW,
                                noBox ? '' : 'bg-white shadow-lg rounded'
                            ]"
                            class="w-full mb-6"
                        >
                            <router-view name="header" />

                            <router-view />

                            <router-view name="footer" />
                        </div>

                        <router-view name="below" />
                    </div>
                </div>
            </div>

            <div class="flex flex-col justify-center flex-none pb-6 text-xs text-center xs:text-left xs:flex-row text-grey-darker">
                <div class="flex-none px-3">
                    <laroute-link :to="{ name: 'www.policies.terms.index' }">
                        Terms,
                    </laroute-link>

                    <laroute-link :to="{ name: 'www.policies.privacy.index' }">
                        Privacy
                    </laroute-link>

                    &amp;

                    <laroute-link :to="{ name: 'www.policies.cookies.index' }">
                        Cookie
                    </laroute-link>

                    policies
                </div>

                <div class="flex-none px-3">
                    &copy; {{ $moment().format('Y') }} Tenant Manager Ltd.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            maxW: {
                type: String,
                default: 'max-w-xs'
            },
            noBox: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
